import { notFound } from 'next/navigation';

const DELETED_PRODUCT_ERROR_CODE = 'ERR_DELETED_PRODUCT';

/** api-fetcher 는 응답 본문(JSON)을 그대로 throw 한다. */
const isDeletedProductError = (error: unknown) =>
  typeof error === 'object' && error !== null && 'errorCode' in error && error.errorCode === DELETED_PRODUCT_ERROR_CODE;

export async function handleProductError(error: unknown): Promise<never> {
  if (isDeletedProductError(error)) {
    notFound();
  }

  throw error;
}
